import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import "firebase/firestore"
// import { initializeApp } from "firebase/app"

const firebaseConfig = {
    apiKey: "AIzaSyCeSOzv0snhpq9i5GJ046F9-7dKxO2XRDY",
    authDomain: "vertihub-7cfc1.firebaseapp.com",
    projectId: "vertihub-7cfc1",
    storageBucket: "vertihub-7cfc1.firebasestorage.app",
    messagingSenderId: "717543934360",
    appId: "1:717543934360:web:ecac1148dbef35bd3503ed"
  };

// const firebaseApp = 
export const firebaseApp = firebase.initializeApp(firebaseConfig)
export const db = firebase.firestore()

db.settings({ timestampsInSnapshots: true }) 